<div class="flex-row height-max">
  <div class="width-200 border-right">
    <div class="center-text">
      <button mat-raised-button
        color="primary"
        class="margin-10"
        (click)="newContractTemplate()">
        + New Template
      </button>
    </div>

    <mat-selection-list #templates
      [multiple]="false"
      (selectionChange)="selectContractTemplate($event.options[0].value)">
      @if (loadingContractTemplates) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @for (contractTemplate of contractTemplates; track contractTemplate) {
        <mat-list-option
          [value]="contractTemplate">
          {{contractTemplate.name}}
        </mat-list-option>
      }
    </mat-selection-list>
  </div>

  <div class="editor-content">
    @if (selectedContractTemplate.contractTemplateId != null) {
      <div class="flex-row width-max">
        <mat-icon class="align-self-center">article</mat-icon>
        &nbsp;
        &nbsp;
        <mat-form-field class="form-field-250">
          <input matInput [(ngModel)]="selectedContractTemplate.name">
        </mat-form-field>
        <mat-form-field class="margin-lr-20">
          <mat-label>Contract Type</mat-label>
          <mat-select [(ngModel)]="selectedContractTemplate.contractTemplateKey" [ngModelOptions]="{standalone: true}">
            @for (contractTemplateKey of contractTemplateKeys | keyvalue; track contractTemplateKey) {
              <mat-option [value]="contractTemplateKey.key">
                {{contractTemplateKey.value}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="margin-left-auto align-self-center flex-row">
          <button mat-raised-button
            color="primary"
            aria-label="Save Contract Template"
            (click)="saveContractTemplate()">
            Save
          </button>
          <div class="width-10"></div>
          <button mat-raised-button
            color="warn"
            aria-label="Delete Contract Template"
            (click)="openDeleteContractTemplatePopup()">
            Delete
          </button>
        </div>
      </div>
    }

    @if (selectedContractTemplate.contractTemplateId == null) {
      <div class="flex-row width-max white-background padding-20">
        <h1>No template selected.</h1>
      </div>
    }

    @if (!savingContractTemplate) {
      <div id="editor-js" class="editor"></div>
    }
  </div>
</div>